/**
 * Fechas "solo día" en selectores: usar calendario local, no UTC (toISOString desplaza un día en muchas zonas).
 */

export function formatLocalDateYMD(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Valores YYYY-MM-DD guardados en filtros/URL: interpretar como fecha local, no como UTC. */
export function parseDateOnlyToLocal(value: unknown): Date {
  const s = String(value).trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (m) {
    const y = Number(m[1]);
    const mo = Number(m[2]) - 1;
    const d = Number(m[3]);
    return new Date(y, mo, d);
  }
  return new Date(s);
}
